import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivityListComponent } from './pages/activity-list/activity-list.component';
import { AccessMediasResolver } from './resolvers/accessmedias.resolvers';


const routes: Routes = [
    { path: '', component: ActivityListComponent, resolve: { accessmedias: AccessMediasResolver }}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AccessMediasResolver
  ]
})
export class ActivityRoutingModule { }
